import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function NavbarComponent() {
  const navigate = useNavigate();
  const [storedUser, setStoredUser] = useState(null);

  // Retrieve session storage data on component load
  useEffect(() => {
    const storedUserdata = sessionStorage.getItem("user");
    if (storedUserdata) {
      setStoredUser(JSON.parse(storedUserdata));
    }
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <Navbar
      style={{
        background: "linear-gradient(90deg, #642b73, #c6426e)", // Darker gradient for contrast
        borderBottom: "2px solid #b35a85",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        padding: "5px 20px",
      }}
      expand="lg"
    >
      {/* Brand Logo */}
      <Navbar.Brand
        href="/dashboard"
        style={{
          color: "#FFD700", // Gold for contrast
          fontWeight: "bold",
          fontSize: "1.3rem",
          letterSpacing: "1px",
        }}
      >
        Ever<span style={{ color: "#ffffff" }}>Found</span>
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto align-items-center">
          {/* Other Links */}
          <Nav.Link
            href="/dashboard"
            style={{ fontSize: "1.1rem", color: "#ffffff" }}
          >
            Dashboard
          </Nav.Link>
          {/* Other Links */}
          <Nav.Link
            href="/recommendation"
            style={{ fontSize: "1.1rem", color: "#ffffff" }}
          >
            Recommendations
          </Nav.Link>
          <Nav.Link
            href="/userprofile"
            style={{ fontSize: "1.1rem", color: "#ffffff" }}
          >
            User Profile
          </Nav.Link>

          {/* Categories Dropdown */}
          <NavDropdown
            title="Categories"
            id="categories-dropdown"
            style={{ fontSize: "1.3rem", color: "#642b73" }} // Match other links
          >
            <NavDropdown.Item
              href="gamingrecommendation"
              style={{ color: "#642b73", backgroundColor: "transparent" }}
              onMouseEnter={(e) => (e.target.style.color = "#FFD700")}
              onMouseLeave={(e) => (e.target.style.color = "#642b73")}
            >
              Gaming
            </NavDropdown.Item>
            <NavDropdown.Item
              href="clothingrecommendation"
              style={{ color: "#642b73", backgroundColor: "transparent" }}
              onMouseEnter={(e) => (e.target.style.color = "#FFD700")}
              onMouseLeave={(e) => (e.target.style.color = "#642b73")}
            >
              Clothing
            </NavDropdown.Item>
            <NavDropdown.Item
              href="/watchrecommendation"
              style={{ color: "#642b73", backgroundColor: "transparent" }}
              onMouseEnter={(e) => (e.target.style.color = "#FFD700")}
              onMouseLeave={(e) => (e.target.style.color = "#642b73")}
            >
              Watches
            </NavDropdown.Item>
            <NavDropdown.Item
              href="/booksrecommendation"
              style={{ color: "#642b73", backgroundColor: "transparent" }}
              onMouseEnter={(e) => (e.target.style.color = "#FFD700")}
              onMouseLeave={(e) => (e.target.style.color = "#642b73")}
            >
              Books
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>

        {/* Keep Logout Button Aligned to the Right */}
        <Nav className="align-items-center ms-auto">
          {" "}
          {/* Changed ml-auto to ms-auto */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #ffffff",
              borderRadius: "5px",
              padding: "6px 15px",
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <PeopleOutlinedIcon
              style={{
                color: "#ffffff",
                marginRight: "8px",
                fontSize: "1.3rem",
              }}
            />
            <span
              style={{
                color: "#ffffff",
                marginRight: "10px",
                fontSize: "1.1rem",
              }}
            >
              {storedUser ? storedUser.name || "User" : "Loading..."}
            </span>

            {/* Logout button */}
            <Button
              variant="outline-light"
              onClick={handleLogout}
              size="sm"
              style={{
                fontSize: "1.0rem",
                color: "#ffffff",
                borderColor: "#ffffff",
              }}
            >
              Logout
            </Button>
          </div>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}
